export const getStyles = (theme) => ({
    sidebar: {
        height: '100%',
        width: '85px',
        backgroundColor: theme.palette.sidebar.background,
        position: 'fixed',
        boxShadow: '2px 0 5px rgba(0, 0, 0, 0.1)',
        color: 'white',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
    }
});
